module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('Prices')
      }
    }
  }, [(_vm.isLoadingStuff) ? _c('div', {
    staticClass: "text-center p-3"
  }, [_c('loader')], 1) : _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Product Pricing")]), _vm._v(" "), (_vm.hasGroupRulesAssociated) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "fs-small color-1"
  }, [_vm._v("Editing is only available if you don't have any Rule Groups associated to this event")])]) : _vm._e(), _vm._v(" "), _c('pricingManager', {
    attrs: {
      "showHeader": false,
      "isEventEditMode": true,
      "group": _vm.getSelectedEvent,
      "priceTypeConfig": {
        isDisable: !this.isCreatingSingleEvent,
        type: 'event'
      },
      "disabled": _vm.hasGroupRulesAssociated
    },
    model: {
      value: (_vm.genderPrices),
      callback: function($$v) {
        _vm.genderPrices = $$v
      },
      expression: "genderPrices"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-af42582a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af42582a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaPrices.vue
// module id = 1487
// module chunks = 0